module.exports = __webpack_public_path__ + "img/icon7.7b4dd4df.png";